<div class="flex items-center justify-center p-7">
	<div class="w-full lg:w-3/5 bg-white rounded overflow-hidden shadow-sm">
		<div class="bg-slate-50 p-7 flex items-center justify-between gap-6">
			<!-- Avatar + badge -->
			<div class="flex flex-col items-center gap-2">
				@if (currentUser$ | async; as user) {
					<img src="images/users/placeholder.png" alt="profile" class="w-20 h-20 rounded-full shadow-sm border border-gray-100">
					@if (user.healthUniqueNumber) {
						<span class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-primary/10 text-primary border border-primary/20 uppercase tracking-wide">
							Utilisateur Enrollé
						</span>
					}
				} @else {
					<img src="images/users/placeholder.png" alt="profile" class="w-20 h-20 rounded-full">
				}
			</div>

			<!-- QR Code -->
			<div class="flex flex-col items-center gap-2">
				@if (qrLoading) {
					<div class="w-24 h-24 flex items-center justify-center bg-white rounded-lg border border-gray-200">
						<svg class="animate-spin h-5 w-5 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
							<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
							<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
						</svg>
					</div>
				} @else if (qrUrl) {
					<img [src]="qrUrl" alt="QR Code" class="w-24 h-24 rounded-lg border border-gray-200 bg-white p-1 shadow-sm cursor-zoom-in" (click)="qrEnlarged = true" title="Agrandir">
					<span class="text-[10px] text-gray-400 uppercase tracking-wide">Mon QR Code</span>
				} @else {
					<button
						type="button"
						(click)="generateQrCode()"
						[disabled]="qrGenerating"
						class="flex items-center gap-2 px-3 py-2 text-xs text-primary border border-primary/30 rounded-md bg-primary/5 hover:bg-primary/10 transition disabled:opacity-50 disabled:cursor-not-allowed"
					>
						@if (qrGenerating) {
							<svg class="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
								<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
								<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
							</svg>
							Génération...
						} @else {
							Générer mon QR Code
						}
					</button>
				}
			</div>
		</div>
		<form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="space-y-4">
			<div class="p-7 space-y-5">
				<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
					<div class="">
						<label class="text-sm required" for="firstName">Prénom</label>
						<input type="text" id="firstName" formControlName="firstName"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full"
							[class.border-red-500]="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched"
							placeholder="Prénom">
						<div *ngIf="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched"
							class="text-red-500 text-xs mt-1">
							<span *ngIf="profileForm.get('firstName')?.errors?.['required']">Le prénom est obligatoire</span>
							<span *ngIf="profileForm.get('firstName')?.errors?.['whitespace']">Le prénom ne peut pas contenir
								uniquement des espaces</span>
						</div>
					</div>
					<div>
						<label class="text-sm required" for="lastName">Nom</label>
						<input type="text" id="lastName" formControlName="lastName"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full"
							[class.border-red-500]="profileForm.get('lastName')?.invalid && profileForm.get('lastName')?.touched"
							placeholder="Nom">
						<div *ngIf="profileForm.get('lastName')?.invalid && profileForm.get('lastName')?.touched"
							class="text-red-500 text-xs mt-1">
							<span *ngIf="profileForm.get('lastName')?.errors?.['required']">Le nom est obligatoire</span>
							<span *ngIf="profileForm.get('lastName')?.errors?.['whitespace']">Le nom ne peut pas contenir uniquement
								des espaces</span>
						</div>
					</div>
				</div>
				@if (currentUser$ | async; as user) {
					@if (user.healthUniqueNumber) {
						<div class="grid grid-cols-1 gap-4">
							<div class="">
								<label class="text-sm required" for="healthUniqueNumber">Numéro unique de santé</label>
								<input type="text" id="healthUniqueNumber" formControlName="healthUniqueNumber" [disabled]="true" readonly
									class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 font-medium"
									placeholder="Passeport Medical">
							</div>
						</div>
					}
				}
				<div class="grid grid-cols-1 gap-4">
					<div class="">
						<label class="text-sm required" for="passportNumber">Passeport Medical</label>
						<input type="text" id="passportNumber" formControlName="passportNumber" [disabled]="true" readonly
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 font-medium"
							placeholder="Passeport Medical">
					</div>
				</div>
				<div class="grid grid-cols-1 gap-4">
					<div class="">
						<label class="text-sm required" for="phone">Login / Téléphone</label>
						<input type="text" id="phone" [disabled]="true" readonly formControlName="phone"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 font-medium"
							placeholder="Téléphone">
					</div>
				</div>
				<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
					<div class="">
						<label class="text-sm" for="email">Email</label>
						<input type="email" id="email" [disabled]="true" readonly formControlName="email"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 font-medium"
							placeholder="Email">
					</div>
					<div>
						<label class="text-sm" for="address">Adresse</label>
						<input type="text" id="address" formControlName="address"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full"
							[class.border-red-500]="profileForm.get('address')?.invalid && profileForm.get('address')?.touched"
							placeholder="Adresse">
						<div *ngIf="profileForm.get('address')?.invalid && profileForm.get('address')?.touched"
							class="text-red-500 text-xs mt-1">
							<span *ngIf="profileForm.get('address')?.errors?.['whitespace']">L'adresse ne peut pas contenir uniquement
								des espaces</span>
						</div>
					</div>
				</div>
				<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
					<div class="">
						<label class="text-sm required" for="dateOfBirth">Date de naissance</label>
						<input type="date" id="dateOfBirth" formControlName="dateOfBirth"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full"
							[class.border-red-500]="profileForm.get('dateOfBirth')?.invalid && profileForm.get('dateOfBirth')?.touched"
							placeholder="Date de naissance">
						<div *ngIf="profileForm.get('dateOfBirth')?.invalid && profileForm.get('dateOfBirth')?.touched"
							class="text-red-500 text-xs mt-1">
							<span *ngIf="profileForm.get('dateOfBirth')?.errors?.['required']">La date de naissance est
								obligatoire</span>
						</div>
					</div>
					<div>
						<label class="text-sm required" for="sex">Sexe</label>
						<select id="sex" formControlName="sex"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full"
							[class.border-red-500]="profileForm.get('sex')?.invalid && profileForm.get('sex')?.touched">
							<option value="">Sélectionner</option>
							<option value="male">Homme</option>
							<option value="female">Femme</option>
						</select>
						<div *ngIf="profileForm.get('sex')?.invalid && profileForm.get('sex')?.touched"
							class="text-red-500 text-xs mt-1">
							<span *ngIf="profileForm.get('sex')?.errors?.['required']">Le sexe est obligatoire</span>
						</div>
					</div>
				</div>
			</div>
			<div class="bg-slate-50 p-5 flex items-center justify-center gap-4">
				<button type="submit" [disabled]="!profileForm.valid || !(hasChanges$ | async) || isLoading"
					class="text-white bg-primary px-4 py-2 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer">
					<span *ngIf="!isLoading">Enregistrer les changements</span>
					<span *ngIf="isLoading" class="flex items-center gap-2">
						<svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
							viewBox="0 0 24 24">
							<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
							<path class="opacity-75" fill="currentColor"
								d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
							</path>
						</svg>
						Enregistrement...
					</span>
				</button>
			</div>
		</form>
	</div>
</div>